// store/modules/user.js
import { sub } from '../../common/event';
import store from '../index';
import req from '../../common/request/index.js';

function persistUser(payload, currentStationId) {
  localStorage.setItem('user', JSON.stringify(payload));
  if (currentStationId) localStorage.setItem('currentStationId', currentStationId);
}

export default {
  namespaced: true,
  state: {
    user: null,
    permissions: [],
    role: '',
    stationId: null,
    managedStationIds: [],
    enterpriseId: null,
    currentStationId: null,
  },
  mutations: {
    setUserData(state, payload) {
      state.user = payload;
      state.permissions = payload.permissions || [];
      state.role = payload.role || '';
      state.stationId = payload.stationId || null;
      state.managedStationIds = payload.managedStationIds || [];
      state.enterpriseId = payload.enterpriseId || null;
      if (payload.currentStationId) state.currentStationId = payload.currentStationId;
      else if (state.managedStationIds.length > 0) state.currentStationId = state.managedStationIds[0];
      else if (state.stationId) state.currentStationId = state.stationId;
    },
    setUserInfo(state, { key, value }) {
      if (state.user) state.user[key] = value;
    },
    setCurrentStationId(state, id) { state.currentStationId = id; },
    clearUser(state) {
      state.user = null;
      state.permissions = [];
      state.role = '';
      state.stationId = null;
      state.managedStationIds = [];
      state.enterpriseId = null;
      state.currentStationId = null;
    },
    updatePermissions(state, payload) { state.permissions = payload; },
  },
  getters: {
    isSuperAdmin: (state) => state.role === 'super_admin',
    isAdmin: (state) => state.role === 'admin',
    isStationLeader: (state) => state.role === 'station_leader',
    hasPermission: (state) => (code) => state.permissions.includes(code),
    availableStations: (state) => {
      if (state.role === 'super_admin') return [];
      if (state.role === 'admin') return state.managedStationIds.map((id) => ({ id }));
      if (state.role === 'station_leader') return state.stationId ? [{ id: state.stationId }] : [];
      return [];
    },
  },
  actions: {
    loginSuccess({ commit }, userInfo) {
      commit('setUserData', userInfo);
      persistUser(userInfo, store.state.user.currentStationId);
    },
    async refreshPermissions({ commit, state }) {
      if (!state.user) return;
      try {
        const ret = await req.api.get(`account/account/current/permissions`);
        if (ret && ret.success) commit('updatePermissions', ret.data);
      } catch (e) {
        console.error('刷新权限失败', e);
      }
    },
    setCurrentStationId({ commit }, id) {
      commit('setCurrentStationId', id);
      localStorage.setItem('currentStationId', id);
    },
    logout({ commit }) {
      commit('clearUser');
      ['user', 'token', 'refreshToken', 'currentStationId', 'openedTabs'].forEach((k) =>
        localStorage.removeItem(k)
      );
    },
  },
    init: async function () {
      const user = localStorage.getItem('user');
      const currentStationId = localStorage.getItem('currentStationId');
      
      if (user) {
        try {
          const parsed = JSON.parse(user);
          if (!parsed.permissions) parsed.permissions = [];
          if (!parsed.managedStationIds) parsed.managedStationIds = [];
          
          store.commit('user/setUserData', parsed);
          if (currentStationId) store.commit('user/setCurrentStationId', currentStationId);
          await store.dispatch('user/refreshPermissions');
        } catch (e) {
          // ★ 容错：如果本地 user 字符串损坏，强制清除并要求重新登录
          console.error('本地用户数据解析失败，已清除并准备重新登录', e);
          ['user', 'token', 'refreshToken', 'currentStationId', 'openedTabs'].forEach((k) =>
            localStorage.removeItem(k)
          );
          window.location.href = '/#/login/login';
          return;
        }
      }
      
      sub('loginSuccess', async (e) => {
        store.commit('user/setUserData', e);
        const st = e.currentStationId || store.state.user.currentStationId;
        persistUser(e, st);
        await store.dispatch('user/refreshPermissions');
      });
    },
};